export default __webpack_public_path__ + "d4dc5bc9cbc0d70f98be41d9f234cc67.png";